module.exports = __webpack_public_path__ + "img/z8.cd1481ec.png";